"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var echarts = _interopRequireWildcard(require("echarts"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'UnionChart',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      chart: null,
      chartType: 'member'
    };
  },
  mounted: function mounted() {
    this.initChart();
    this.updateChart();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart: function initChart() {
      var _this = this;
      this.chart = echarts.init(this.$refs.chart);
      window.addEventListener('resize', function () {
        _this.chart && _this.chart.resize();
      });
    },
    updateChart: function updateChart() {
      if (!this.chart) return;
      var option = {};
      switch (this.chartType) {
        case 'member':
          option = this.getMemberChartOption();
          break;
        case 'discount':
          option = this.getDiscountChartOption();
          break;
        case 'trend':
          option = this.getTrendChartOption();
          break;
      }
      this.chart.setOption(option, true);
    },
    getMemberChartOption: function getMemberChartOption() {
      var data = this.data.memberDistribution || [];
      return {
        title: {
          text: '工会会员分布',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          data: data.map(function (item) {
            return item.name;
          })
        },
        series: [{
          name: '会员分布',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['40%', '50%'],
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          }
        }]
      };
    },
    getDiscountChartOption: function getDiscountChartOption() {
      var categories = this.data.discountCategories || [];
      var values = this.data.discountValues || [];
      return {
        title: {
          text: '工会折扣率分析',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '工会数量'
        },
        series: [{
          name: '工会数量',
          type: 'bar',
          barWidth: '60%',
          data: values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#409EFF'
            }, {
              offset: 1,
              color: '#64B5F6'
            }]),
            borderRadius: [4, 4, 0, 0]
          }
        }]
      };
    },
    getTrendChartOption: function getTrendChartOption() {
      var months = this.data.trendMonths || [];
      var unionTrend = this.data.unionTrend || [];
      var memberTrend = this.data.memberTrend || [];
      return {
        title: {
          text: '工会发展趋势',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['工会数量', '会员数量'],
          bottom: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: months
        },
        yAxis: [{
          type: 'value',
          name: '工会数量',
          position: 'left'
        }, {
          type: 'value',
          name: '会员数量',
          position: 'right'
        }],
        series: [{
          name: '工会数量',
          type: 'line',
          yAxisIndex: 0,
          data: unionTrend,
          smooth: true,
          lineStyle: {
            width: 3
          },
          itemStyle: {
            color: '#409EFF'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(64, 158, 255, 0.3)'
            }, {
              offset: 1,
              color: 'rgba(64, 158, 255, 0.1)'
            }])
          }
        }, {
          name: '会员数量',
          type: 'line',
          yAxisIndex: 1,
          data: memberTrend,
          smooth: true,
          lineStyle: {
            width: 3
          },
          itemStyle: {
            color: '#67C23A'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(103, 194, 58, 0.3)'
            }, {
              offset: 1,
              color: 'rgba(103, 194, 58, 0.1)'
            }])
          }
        }]
      };
    }
  },
  watch: {
    data: {
      handler: function handler() {
        this.updateChart();
      },
      deep: true
    }
  }
};